const TransTls = {
    getInfo(subRow){
        var t = 'a_sub';
        if('section_model' in subRow) t = 'l_sub';
        let info = '';
        info += "Feeder ID: " + subRow.feeder_id;
        info += "Name: " + subRow.sub_name;
        info += '<br><a target="_blank" href="#/simple-edit/'+t+'/_id/'+subRow._id+'" >سلام</a>';
        return info;
      
    }
}


export {TransTls}